<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-user-places">

        <page-title :title="'Twoje lokale'" :back="true"></page-title>

        <slide-y-up-transition :duration="400" :delay="200">
            <p v-if="show && places.length === 0" class="text-center">Nie masz jeszcze żadngo lokalu.</p>
        </slide-y-up-transition>

        <div v-for="(item,index) in places" :key="item.slug">
            <item-user-place
                    :index="index+1"
                    :facility_slug="$route.params.slug"
                    :place_slug="item.slug"
                    :city_name="item.city_name"
                    :name="item.name"
                    :street="item.street"
                    :ebi="item.ebi"
                    :tax_id="item.tax_id"
                    :zip_code="item.zip_code"
                    :image="item.image">
            </item-user-place>
        </div>

        <ion-button mode="ios"
                    expand="block"
                    class="mt-10"
                    @click="goTo('UserPlacesDetail', $route.params.slug, 'Dodaj nowy lokal', 'nowy-lokal')">Dodaj nowy lokal
        </ion-button>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import ItemUserPlace from '@/items/ItemUserPlace'
    import goTo from '@/mixins/goto';

    export default{
        name: 'UserPlaces',
        components: { PageTitle, ItemUserPlace },
        mixins: [goTo],
        data(){
            return {
                show: false
            }
        },
        computed: {
            ...mapState({
                errors: state => state.facilities.errors,
                loading: state => state.facilities.loading,
                places: state => state.facilities.places,
            })
        },
        mounted(){
            this.show = true;
            this.$store.dispatch('facilities/USER_FACILITIES_PLACES_REQUEST', this.$route.params.slug)
        }
    }
</script>